import { render } from "./AddPhoneNumber.vue?vue&type=template&id=3fc0c630&scoped=true&ts=true"
import script from "./AddPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./AddPhoneNumber.vue?vue&type=script&lang=ts"

import "./AddPhoneNumber.vue?vue&type=style&index=0&id=3fc0c630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc0c630"]])

export default __exports__